import clsx from 'clsx'

type HeadingProps = {
  level?: 1 | 2 | 3 | 4 | 5 | 6
  size?: 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl'
} & React.ComponentPropsWithoutRef<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'>

export function Heading({ className, level = 1, size = '4xl', ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`

  const sizes = {
    md: 'text-base/8',
    lg: 'text-lg/8',
    xl: 'text-xl/8',
    '2xl': 'text-2xl/8',
    '3xl': 'text-3xl/8',
    '4xl': 'text-4xl/8',
  }

  return (
    <Element
      { ...props }
      className={ clsx(
        className,
        sizes[size],
        'font-semibold text-zinc-950 dark:text-white'
      ) }
    />
  )
}

export function Subheading({ className, level = 2, ...props }: HeadingProps) {
  const Element: `h${typeof level}` = `h${level}`

  return (
    <Element
      { ...props }
      className={ clsx(
        className,
        'text-base/7 font-semibold text-zinc-950 sm:text-sm/6 dark:text-white'
      ) }
    />
  )
}
